module.exports = __webpack_public_path__ + "static/media/Watertower_4.db1868a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/watertower/Watertower_4.png
// module id = 1276
// module chunks = 3